import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CancellationReasonsPage } from './cancellation-reasons.page';

const routes: Routes = [
  {
    path: '',
    component: CancellationReasonsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CancellationReasonsPageRoutingModule {}
